/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_FailInputs */

const en_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail`)
};

const fr_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeter`)
};

const de_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheitern`)
};

const it_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallire`)
};

const ru_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неудача`)
};

const es_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallar`)
};

const zh_cn2_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

const ja_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗`)
};

const hi_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल`)
};

const pt_pt2_context_menu_fail = /** @type {(inputs: Context_Menu_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhar`)
};

/**
* | output |
* | --- |
* | "Fail" |
*
* @param {Context_Menu_FailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_fail = /** @type {((inputs?: Context_Menu_FailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_FailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_fail(inputs)
	if (locale === "de") return de_context_menu_fail(inputs)
	if (locale === "it") return it_context_menu_fail(inputs)
	if (locale === "ru") return ru_context_menu_fail(inputs)
	if (locale === "es") return es_context_menu_fail(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_fail(inputs)
	if (locale === "ja") return ja_context_menu_fail(inputs)
	if (locale === "hi") return hi_context_menu_fail(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_fail(inputs)
	return en_context_menu_fail(inputs)
});